import * as React from "react"
import {AppLink} from "@ui-seeker/app";
import {Box} from "@mui/material";


export default function PercentageChartNewElementLinkWrapper({ link, children, ...props }) {
	if (link)
		return <AppLink to={link} target="_blank" {...props}>
			{children}
		</AppLink>

    return <Box {...props}>
		{children}
    </Box>
}